import teamImg1 from 'app/assets/images/team-img-1.jpg'
import teamImg2 from 'app/assets/images/team-img-2.jpg'
import teamImg3 from 'app/assets/images/team-img-3.jpg'
import teamImg4 from 'app/assets/images/team-img-4.jpg'
import teamImg5 from 'app/assets/images/team-img-5.jpg'
import teamImg6 from 'app/assets/images/team-img-6.jpg'

export const doctorsArray = [
  {
    id: 1,
    name: "Dr. James Garcia",
    title: "MD",
    position: "Cardiologist",
    description: "Dr. Garcia is a highly experienced cardiologist with a focus on the diagnosis and treatment of heart disease. He has been practicing medicine for over 15 years and has helped thousands of patients manage their cardiovascular health. Dr. Garcia is known for his compassionate approach and dedication to his patients.",
    rating: 4.9,
    experience: "15 years",
    url: "/team/dr-james-garcia",
    img: teamImg1
  },
  {
    id: 2,
    name: "Dr. Sarah Patel",
    title: "DO",
    position: "Pediatrician",
    description: "Dr. Patel is a caring and knowledgeable pediatrician with a passion for providing high-quality healthcare to children of all ages. She completed her medical degree at the University of California, Los Angeles and has been practicing for 10 years. Dr. Patel is committed to working with families to develop personalized treatment plans that meet the unique needs of each child.",
    rating: 4.6,
    experience: "10 years",
    url: "/team/dr-sarah-patel",
    img: teamImg2
  },
  {
    id: 3,
    name: "Dr. Daniel Kim",
    title: "MD",
    position: "Oncologist",
    description: "Dr. Kim is a dedicated and compassionate oncologist with a passion for helping patients overcome cancer. He completed his medical degree at Harvard Medical School and has been practicing for over 20 years. Dr. Kim has extensive experience in the diagnosis, treatment, and management of various types of cancer, and is known for his expertise and caring approach.",
    rating: 4.8,
    experience: "20 years",
    url: "/team/dr-daniel-kim",
    img: teamImg3
  },
  {
    id: 4,
    name: "Dr. Lauren Chen",
    title: "DO",
    position: "Family Physician",
    description: "Dr. Chen is a dedicated and compassionate family physician with a focus on preventive care and disease management. She completed her medical degree at the University of California, San Francisco and has been practicing for 12 years. Dr. Chen takes a holistic approach to healthcare and works closely with her patients to develop personalized treatment plans that address their unique health concerns.",
    rating: 4.7,
    experience: "12 years",
    url: "/team/dr-lauren-chen",
    img: teamImg4
  },
  {
    id: 5,
    name: "Dr. Jennifer Lee",
    position: "Family Physician",
    title: "MD",
    description: `Dr. Lee is a board-certified family medicine physician with over 10 years of experience in primary care. She is passionate about preventative medicine and enjoys working with patients to help them achieve their health goals. Her areas of expertise include chronic disease management, women's health, and pediatrics.`,
    rating: 4.5,
    experience: 12,
    url: "/team/dr-jennifer-lee",
    img: teamImg5
  },
  {
    name: "Dr. Michael Patel",
    position: "Dermatologist",
    title: "MD",
    description: `Dr. Patel is a skilled dermatologist with expertise in treating a wide range of skin conditions. He is committed to staying up-to-date on the latest research and treatment methods in his field. In his spare time, he enjoys hiking, mountain climbing and practicing yoga.`,
    rating: 4.8,
    experience: 8,
    url: "/team/dr-michael-patel",
    img: teamImg6
  }
]